import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const SelectDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		drop: 'bottom-start'
	},
	styles: {
		input: {
			...( textVariants.body as CSSObject ),
			'color': 'black',
			'border': '1px solid var(--mantine-color-gray-4)',
			'backgroundColor': '#FBFBFB',
			'borderRadius': '4px',
			'padding': '4px 8px',
			'&::placeholder': {
				...( textVariants.body as CSSObject )
			}
		},
		values: {
			'minHeight': '34px'
		},
		value: {
			'backgroundColor': 'var(--mantine-color-blue-0)',
			'color': 'var(--mantine-color-blue-5)',
			'border': '1px solid var(--mantine-color-blue-2)'
		},
		label: {
			...( textVariants[ 'body-bold' ] as CSSObject ),
			marginBottom: 8
		},
		item: {
			...( textVariants.body as CSSObject ),
			'color': 'black'
		},
		wrapper: {
			'pointerEvents': 'all'
		},
		dropdown: {
			'border': '1px solid var(--mantine-color-gray-4)',
			'marginTop': -4,
			'borderRadius': '4px'
		}
	}
};

export default SelectDefaultConfig;
